import React from "react";
import { Link, useLocation } from "wouter";
import { KeyIcon, MessagesSquare, LogOut, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useAdminAuth } from "@/contexts/admin-auth";
import LoginScreen from "@/components/login-screen";

const NAV = [
  { href: "/admin/api-keys", label: "Chaves de API", icon: KeyIcon },
  { href: "/admin/assessments", label: "Avaliações", icon: MessagesSquare },
  { href: "/admin/feedbacks", label: "Feedbacks", icon: MessageCircle },
];

function Sidebar({ onLogout }: { onLogout: () => void }) {
  const [location] = useLocation();
  return (
    <aside className="w-56 shrink-0 bg-card border-r flex flex-col min-h-[100dvh] sticky top-0">
      <div className="flex items-center gap-2 px-5 py-5 border-b">
        <div className="w-7 h-7 rounded-md bg-primary flex items-center justify-center">
          <span className="text-primary-foreground font-bold text-sm">D</span>
        </div>
        <span className="font-semibold text-sm">DISC Admin</span>
      </div>
      <nav className="flex-1 py-4 px-3 space-y-1">
        {NAV.map(({ href, label, icon: Icon }) => (
          <Link
            key={href}
            href={href}
            className={cn(
              "flex items-center gap-2.5 px-3 py-2 rounded-md text-sm font-medium transition-colors no-underline",
              location.startsWith(href)
                ? "bg-primary/10 text-primary"
                : "text-muted-foreground hover:bg-muted hover:text-foreground",
            )}
          >
            <Icon className="h-4 w-4 shrink-0" />
            {label}
          </Link>
        ))}
      </nav>
      <div className="p-3 border-t">
        <Button variant="ghost" size="sm" className="w-full justify-start text-muted-foreground" onClick={onLogout} data-testid="button-logout">
          <LogOut className="h-4 w-4 mr-2" />
          Sair
        </Button>
      </div>
    </aside>
  );
}

export default function AdminLayout({ children }: { children: React.ReactNode }) {
  const { authHeader, logout } = useAdminAuth();
  if (!authHeader) return <LoginScreen />;
  return (
    <div className="flex min-h-[100dvh] bg-background">
      <Sidebar onLogout={logout} />
      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}
